import { render, staticRenderFns } from "./sidebarSection.vue?vue&type=template&id=9ce3e9ca"
import script from "./sidebarSection.vue?vue&type=script&lang=js"
export * from "./sidebarSection.vue?vue&type=script&lang=js"
import style0 from "./sidebarSection.vue?vue&type=style&index=0&id=9ce3e9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports